import {
  type AffineFormatBarWidget,
  AIStarIcon,
  toolbarDefaultConfig,
} from '@blocksuite/affine/blocks';
import { t } from '@blocksuite/docnboard-i18n';
import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

import { askAICommand } from '../../commands';

export function setupFormatBarAIEntry(formatBar: AffineFormatBarWidget) {
  toolbarDefaultConfig(formatBar);
  // FIXME после переключения языка не обновляется
  formatBar.addRawConfigItems(
    [
      {
        id: 'ai',
        name: t('docnboard.ai.ask-ai'),
        type: 'inline-action',
        icon: html`<div
          style=${styleMap({
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          })}
        >
          ${AIStarIcon} ${t('docnboard.ai.ask-ai')}
        </div>`,
        isActive: () => false,
        action: (_chain, formatBar) => {
          formatBar.reset();
          askAICommand(formatBar.std);
        },
        showWhen: chain => {
          const [_, ctx] = chain
            .getSelectedModels({
              types: ['block', 'text'],
              mode: 'highest',
            })
            .run();
          const { selectedModels } = ctx;
          return !!selectedModels && selectedModels.length > 0;
        },
      },
      { type: 'divider' },
    ],
    0
  );
}
